<div cdkDropList class="flujo-nodo-lista grid" (cdkDropListDropped)="onDrop($event)">
    <div class="col-12 md:col-6 lg:col-4" *ngFor="let nodoForm of controles; let i = index" cdkDrag>
        <app-flujo-nodo
            [nodoForm]="$any(nodoForm)"
            [esInicial]="esInicial(nodoForm)"
            [numero]="i + 1"
            [disparador]="disparadorDe(nodoForm)"
            [sinFinal]="sinFinalDe(nodoForm)"
            [inalcanzable]="inalcanzableDe(nodoForm)"
            (editar)="editarNodo.emit(i)"
            (eliminar)="eliminarNodo.emit(i)"
        ></app-flujo-nodo>
    </div>

    <div class="col-12" *ngIf="!controles.length">
        <p class="text-500">Todavía no hay pasos. Agregá el primero para empezar a armar la conversación.</p>
    </div>
</div>
